import { VEHICLE_RELATION_TITLES } from './constants';

export { VEHICLE_RELATION_OPTIONS } from './constants';

export type VehicleRelation = keyof typeof VEHICLE_RELATION_TITLES;

export function titleForVehicleRelation(
  vehicleRelation?: VehicleRelation,
): string {
  if (!vehicleRelation) {
    return '';
  }
  return VEHICLE_RELATION_TITLES[vehicleRelation];
}

export function formatName(contact?: {
  firstName?: string;
  lastName?: string;
}): string {
  if (!contact) return '';

  const { firstName, lastName } = contact;
  return [firstName, lastName].filter(Boolean).join(' ');
}
